import React, { ReactNode, createContext, useContext } from 'react';
import RequiredHint from './RequiredHint';

export type FormConfig = {
  requiredLabel?: ReactNode;
};

export const FormConfigContext = createContext<FormConfig>({});

export const FormConfigProvider = FormConfigContext.Provider;

export const useFormConfig = (): FormConfig => useContext(FormConfigContext);

let globalFormConfig: FormConfig = {
  requiredLabel: <RequiredHint />,
};

export function getGlobalFormConfig(): FormConfig {
  return globalFormConfig;
}

export function updateGlobalFormConfig(newConfig: FormConfig | ((current: FormConfig) => FormConfig)): void {
  if (typeof newConfig === 'function') {
    globalFormConfig = newConfig(globalFormConfig);
  } else {
    globalFormConfig = newConfig;
  }
}
